// extracted by mini-css-extract-plugin
export default {"signupDetailsForm":"SignupDetailsForm_signupDetailsForm__jJeHN","row":"SignupDetailsForm_row__YNTlv","sumbitButton":"SignupDetailsForm_sumbitButton__O5rhe"};